export interface UnitPriceCsvExportParams {
  startDate: string;
  endDate: string;
  isTokyo: boolean;
  isDairen: boolean;
}

export const EmptyUnitPriceCsvExportParams: UnitPriceCsvExportParams = {
  startDate: '',
  endDate: '',
  isTokyo: true,
  isDairen: false,
};
